import React, {useState, useEffect} from 'react'

import {useRouter} from 'next/router'

import {PageContainer} from 'src/components/layout'
import {SearchResults} from 'src/components/search'
import type {GetStaticProps} from 'next'
import {makeSubscriptionProps} from 'src/api/datocms/utils'
import {pageQuery} from 'src/api/datocms/queries'
import {DEFAULT_REVALIDATE_TIME} from 'src/const'

export const getStaticProps: GetStaticProps = async ({preview = false}) => ({
  props: {
    pageSubscription: await makeSubscriptionProps(preview, pageQuery, true),
  },
  revalidate: DEFAULT_REVALIDATE_TIME,
})

export default function Leit(): JSX.Element {
  const [query, setQuery] = useState<string>()
  const router = useRouter()

  const searchQuery = router.query.q as string
  useEffect(() => {
    if (searchQuery !== query) {
      setQuery(searchQuery)
    }
  }, [searchQuery, query])

  return (
    <PageContainer title="Leit | Rekstrarvörur">
      {query && <SearchResults query={query} />}
    </PageContainer>
  )
}
